import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createCatalogRecord } from "src/business/records/apiRecords";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { submitMForm } from "src/components/MForm/submitMForm";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { CatalogRecordForm } from "../CatalogRecordForm";
import { newRecordStore as pageStore } from "./newRecordStore";

export const NewRecordPage: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.breadcrumbs}>
      <LoaderBox remoteData={pageStore.data} drawReady={() => <Inner />} />
    </PageLayout>
  );
});

const Inner: React.FC = observer(() => {
  const navigate = useNavigate();
  const { cdsFormStore } = pageStore;
  if (!cdsFormStore) return null;
  return (
    <CatalogRecordForm
      title="Новая запись"
      okText="Создать"
      store={cdsFormStore}
      submit={(values) =>
        submitMForm(
          () => createCatalogRecord(pageStore.catalogId, values),
          cdsFormStore.errorsStore,
        )
      }
      onSuccess={({ id }) => {
        msgQueueStore.add({ type: "success", message: "Создана новая запись" });
        pageStore.cdsFormStore?.setAsUnchanged();
        navigate(makeUrl(PageUrl.editRecord, { id }), { replace: true });
      }}
    />
  );
});
